import { render, staticRenderFns } from "./TransparencyProgramModal.ts.vue?vue&type=template&id=ead60ec8"
import script from "./TransparencyProgramModal.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransparencyProgramModal.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TransparencyProgramModal.ts.vue?vue&type=style&index=0&id=ead60ec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports